// @flow

import { checkStatus, parseJSON } from '../../web/Utils/utils'
import {
    BackendURL,
    LoginURL,
    JWTLoginURL,
    LogoutURL,
    LogAccessUrl,
    JWTMaskURL,
} from '../App/Constants/AppData';

export const RETRIEVE_TOKEN_START = 'Session/RETRIEVE_TOKEN_START';
export const RETRIEVE_TOKEN_SUCCESS = 'Session/RETRIEVE_TOKEN_SUCCESS';
export const RETRIEVE_TOKEN_FAILED = 'Session/RETRIEVE_TOKEN_FAILED';
export const REVIVE_TOKEN_SUCCESS = 'Session/REVIVE_TOKEN_SUCCESS';
export const RETRIEVE_PROFILE_START = 'Session/RETRIEVE_PROFILE_START';
export const RETRIEVE_PROFILE_SUCCESS = 'Session/RETRIEVE_PROFILE_SUCCESS';
export const RETRIEVE_PROFILE_FAILED = 'Session/RETRIEVE_PROFILE_FAILED';
export const RETRIEVE_TEAM_START = 'Session/RETRIEVE_TEAM_START';
export const RETRIEVE_TEAM_SUCCESS = 'Session/RETRIEVE_TEAM_SUCCESS';
export const RETRIEVE_TEAM_FAILED = 'Session/RETRIEVE_TEAM_FAILED';
export const LOG_OUT = 'Session/LOG_OUT';
export const SEND_LOG_ACCESS_SUCCESS = 'Session/SEND_LOG_ACCESS_SUCCESS';
export const SEND_LOG_ACCESS_FAILED = 'Session/SEND_LOG_ACCESS_FAILED ';
export const SAML_TOKEN_START = 'Session/SAML_TOKEN_START';
export const SAML_TOKEN_SUCCESS = 'Session/SAML_TOKEN_SUCCESS';
export const SAML_TOKEN_FAILED = 'Session/SAML_TOKEN_FAILED';

function getToken ( user, pass ) {
    return new Promise ( ( resolve, reject ) => {
        fetch ( LoginURL, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify ( { name: user, pass: pass } ),
            credentials: 'omit'
        } )
            .then ( checkStatus )
            .then ( parseJSON )
            .then ( res => {
                console.log('resolve', resolve)
                resolve ( res );
            } ).catch ( error => {
            logOut ();
            // console.error( "Error: ", error );
            parseLoginError ( error ).then ( reject )
        } )
    } )
}

// Backend answers 403 { message, code: 'saml_required' } when the user must sign in with Microsoft.
function parseLoginError ( error ) {
    if ( !( error instanceof Response ) || error.status !== 403 ) {
        return Promise.resolve ( error );
    }

    return error.json ()
        .then ( body => body && body.code
            ? { status: error.status, statusText: body.message, code: body.code }
            : error
        )
        .catch ( () => error );
}

function sendLog(user, reason, token) {
    return new Promise ( ( resolve, reject ) => {
        const dateTimeToSend = new Date().toString;
        let myHeaders = new Headers ();
        myHeaders.append ( "Content-Type", "application/vnd.api+json" );
        myHeaders.append ( "Accept", "application/vnd.api+json" );
        myHeaders.append ( "Authorization", "Bearer " + token)
        const reasonData = JSON.stringify({
            "data": {
                "type": "accesslog--accesslog",
                "attributes": {
                    "field_accesslog_access_reason": reason,
                    "field_accesslog_datetime": dateTimeToSend,
                    "field_accesslog_username": user
                },
                "relationships": {
                    "accesslog_type": {
                        "data": {
                            "type": "accesslog_type--accesslog_type",
                            "id": "cb66cdeb-a5b3-4a95-b906-2cec9c1409ea"
                        },
                        "links": {
                            "related": {
                                "href": "https://werfen-docs-cms.ddev.site/jsonapi/accesslog/accesslog/12623413-a736-417e-9b82-816538aca639/accesslog_type"
                            },
                            "self": {
                                "href": "https://werfen-docs-cms.ddev.site/jsonapi/accesslog/accesslog/12623413-a736-417e-9b82-816538aca639/relationships/accesslog_type"
                            }
                        }
                    }
                }
            }
        });
        fetch ( LogAccessUrl, {
            method: 'POST',
            headers: myHeaders,
            body: reasonData
        } )
            .then ( checkStatus )
            .then ( parseJSON )
            .then ( res => {
                resolve ( res );
            } ).catch ( error => {
            console.error( "Error ON sendLog: ", error );
            reject ( error )
        } )
    });
}

function getTokenFromToken ( loginToken ) {
    logOut ();
    return new Promise ( ( resolve, reject ) => {
        fetch ( JWTLoginURL, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify ( { token: loginToken } )
        } )
            .then ( checkStatus )
            .then ( parseJSON )
            .then ( res => {
                resolve ( res );
            } ).catch ( error => {
            logOut ();
            if ( process.env.REACT_APP_LOGIN_BY_TOKEN === "1" ) {
                window.location.replace ( process.env.REACT_APP_REDIRECT_FOR_LOGIN );
            }
            // console.error( "Error: ", error );
            reject ( error )
        } )
    } )
}

function getTokenFromMask ( token ) {
    logOut ();
    return new Promise ( ( resolve, reject ) => {
        fetch ( JWTMaskURL, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify ( { token: token } )
        } )
          .then ( checkStatus )
          .then ( parseJSON )
          .then ( res => {
              resolve ( res );
          } ).catch ( error => {
            logOut ();
            reject ( error )
        } )
    } )
}

function getEmployeeSapProfile ( profileUUID ) {
    return new Promise ( ( resolve, reject ) => {
        let myHeaders = new Headers ();
        myHeaders.append ( "Content-Type", "application/vnd.api+json" );
        myHeaders.append ( "Accept", "application/vnd.api+json" );
        myHeaders.append ( "Authorization", "Bearer " + localStorage.getItem ( "token" ) );

        const URL = BackendURL + "/jsonapi/profile/employee_sap/" + profileUUID + "?include=field_employee_sap_sales_org";

        const requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch ( URL, requestOptions )
            .then ( parseJSON )
            .then ( res => {
                resolve ( res );
            } ).catch ( error => {
            reject ( error )
        } )
    } )
}

export function getExecutorTeam ( userUUID ) {
    return new Promise ( ( resolve, reject ) => {
        let myHeaders = new Headers ();
        myHeaders.append ( "Content-Type", "application/vnd.api+json" );
        myHeaders.append ( "Accept", "application/vnd.api+json" );
        myHeaders.append ( "Authorization", "Bearer " + localStorage.getItem ( "token" ) );

        const URL = BackendURL + "/jsonapi/executors_team/executors_team?include=field_executors_team_members&filter[field_executors_team_members.id]=" + userUUID;

        const requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch ( URL, requestOptions )
            .then ( parseJSON )
            .then ( res => {
                resolve ( res );
            } ).catch ( error => {
            reject ( error )
        } )
    } )
}

export function retrieveToken ( user, pass ) {
    return {
        types: [ RETRIEVE_TOKEN_START, RETRIEVE_TOKEN_SUCCESS, RETRIEVE_TOKEN_FAILED ],
        promise: () => getToken ( user, pass )
    }
}

export function sendAccessLog (user, reason, token) {
    return {
        types: [SEND_LOG_ACCESS_SUCCESS, SEND_LOG_ACCESS_FAILED],
        promise: () => sendLog ( user, reason, token )
    }
}

export function retrieveTokenFromToken ( user, pass ) {
    return {
        types: [ RETRIEVE_TOKEN_START, RETRIEVE_TOKEN_SUCCESS, RETRIEVE_TOKEN_FAILED ],
        promise: () => getTokenFromToken ( user, pass )
    }
}

export function retrieveTokenFromMask ( token ) {
    return {
        types: [ RETRIEVE_TOKEN_START, RETRIEVE_TOKEN_SUCCESS, RETRIEVE_TOKEN_FAILED ],
        promise: () => getTokenFromMask( token )
    }
}

export function retrieveTokenFromSaml ( token ) {
    return {
        types: [ SAML_TOKEN_START, SAML_TOKEN_SUCCESS, SAML_TOKEN_FAILED ],
        promise: () => getTokenFromMask( token )
    }
}

export function retrieveEmployeeSapProfile ( profileUUID ) {
    return {
        types: [ RETRIEVE_PROFILE_START, RETRIEVE_PROFILE_SUCCESS, RETRIEVE_PROFILE_FAILED ],
        promise: () => getEmployeeSapProfile ( profileUUID )
    }
}

export function retrieveExecutorTeam ( userUUID ) {
    return {
        types: [ RETRIEVE_TEAM_START, RETRIEVE_TEAM_SUCCESS, RETRIEVE_TEAM_FAILED ],
        promise: () => getExecutorTeam ( userUUID )
    }
}

export function reviveToken ( obj ) {
    const { username, token, isEmployee, userUUID, ticketingUUID, teamUUID, profileUUID } = obj;
    let payload = {
        jwt_access_token: token,
        current_user: username,
        isEmployee: isEmployee,
    }
    if ( process.env.REACT_APP_SEE_TICKETS === "1" ) {
        payload = {
            ...payload,
            userUUID,
            ticketingUUID,
            teamUUID,
            profileUUID
        }
    }
    return {
        type: REVIVE_TOKEN_SUCCESS,
        payload
    }
}

export function logOut () {
    // noinspection JSUnusedLocalSymbols
    fetch ( LogoutURL, {
        method: 'POST',
        headers: {
            'Accept': 'text/html',
            'Content-Type': 'text/html',
        },
    } ).catch ( error => {
        // console.error( "Error: ", error );
    } )
    return {
        type: LOG_OUT
    }

}
